import { nFormatter } from 'lib/utils/helpers/numberFormat';
import { PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
  children?: string;
  value?: number;
}

function NumberText(props: Props) {
  const { children, value } = props;

  return <>{nFormatter(value === undefined ? parseInt(children!) : value)}</>;
}

export default NumberText;
